module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-info"
    }
  }, [_c('div', {
    staticClass: "title semibold mb-4"
  }, [_vm._v("Profile Information")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "First Name"
    },
    model: {
      value: (_vm.user.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "first_name", $$v)
      },
      expression: "user.first_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Name"
    },
    model: {
      value: (_vm.user.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "last_name", $$v)
      },
      expression: "user.last_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.roles,
      "label": "Role"
    },
    model: {
      value: (_vm.user.role),
      callback: function($$v) {
        _vm.$set(_vm.user, "role", $$v)
      },
      expression: "user.role"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40bc0434","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/users/login-info.vue
// module id = 662
// module chunks = 1